<script setup lang="ts">
import { useBrowserLocation } from "@vueuse/core";
import VButton from "@magnit/core/src/components/VButton/VButton.vue";
import VHidden from "@magnit/core/src/components/VHidden/VHidden.vue";
import VStack from "@magnit/core/src/components/VStack/VStack.vue";
import VStackItem from "@magnit/core/src/components/VStack/VStackItem.vue";
import VIcon from "@magnit/icons/src/components/VIcon/VIcon.vue";
import VkLogo from "@magnit/icons/src/assets/svg/icons/base/40-social-network-vk.svg";
import TelegramLogo from "@magnit/icons/src/assets/svg/icons/base/40-social-network-telegram.svg";
import OkLogo from "@magnit/icons/src/assets/svg/icons/base/40-social-network-okru.svg";
import { useCategoriesStore } from "~/store/categories";

interface IProductShareContentProps {
  id: string;
  name?: string;
  categoryKey: string;
  discountCategory?: string;
}

const props = defineProps<IProductShareContentProps>();

const categoriesStore = useCategoriesStore();
const { $toast } = useNuxtApp();
const { send } = useAnalytics();
const location = useBrowserLocation();

const onCopy = () => {
  if (location.value.href) {
    window.navigator.clipboard.writeText(location.value.href).then(() => {
      onItemClick("link");
      $toast.success({ title: "Ссылка скопирована" });
    });
  }
};

const onItemClick = (social: "vk" | "tg" | "ok" | "link") => {
  const treeName = categoriesStore.getTreeNameByKey(props.categoryKey);
  send("CardDetail:ShareSocials:Click", {
    categoryName: treeName,
    name: props.name,
    product_id: props.id,
    discountCategory: props.discountCategory,
    social_type: social,
  });
};
</script>

<template>
  <div class="product-share-content">
    <VStack
      class="product-share-content__buttons"
      :direction="{ xs: 'column', m: 'row' }"
      :wrap="{ xs: 'wrap', m: 'nowrap' }"
      gap="12px"
    >
      <VStackItem :size="{ xs: 12, m: 'auto' }">
        <VStack direction="row" justify="center" gap="12px" wrap="nowrap">
          <a
            class="product-share-content__item"
            :href="`https://vk.com/share.php?url=${
              location.href && encodeURIComponent(location.href)
            }`"
            target="_blank"
            @click="onItemClick('vk')"
          >
            <VkLogo />
          </a>
          <a
            class="product-share-content__item"
            :href="`https://t.me/share/url?url=${
              location.href && encodeURIComponent(location.href)
            }`"
            target="_blank"
            @click="onItemClick('tg')"
          >
            <TelegramLogo />
          </a>
          <a
            class="product-share-content__item"
            :href="`https://connect.ok.ru/offer?url=${
              location.href && encodeURIComponent(location.href)
            }`"
            target="_blank"
            @click="onItemClick('ok')"
          >
            <OkLogo />
          </a>
        </VStack>
      </VStackItem>

      <VStackItem :size="{ xs: 12, m: 'auto' }">
        <VHidden :hide="{ xs: false, m: true }">
          <VButton
            theme="secondary"
            icon-position="right"
            full-width
            @click="onCopy"
          >
            Скопировать ссылку
            <template #icon>
              <VIcon name="24-outline-copy" />
            </template>
          </VButton>
        </VHidden>

        <VHidden :hide="{ xs: true, m: false }">
          <VButton theme="secondary" @click="onCopy">
            <template #icon>
              <VIcon name="24-outline-copy" />
            </template>
          </VButton>
        </VHidden>
      </VStackItem>
    </VStack>
  </div>
</template>

<style lang="postcss" scoped>
.product-share-content {
  &__item {
    display: flex;

    & svg {
      width: 56px;
      height: 56px;
    }
  }
}
</style>
